export default __webpack_public_path__ + "static/media/trade-page-full.82db4c50.png";